import React from 'react';
import { Box, Tooltip } from '@mui/material';

// the visit's plate with the character that differs from the searched / read one marked
export default function DiffPlate({ plate, diff }) {
    if (!diff) return plate;
    const mark = (ch, title) => (
        <Tooltip title={title}>
            <Box
                component="span"
                sx={{ bgcolor: 'warning.light', color: 'error.dark', borderRadius: 0.5, px: 0.25 }}
            >
                {ch}
            </Box>
        </Tooltip>
    );
    const { pos } = diff;
    if (diff.op === 'missing') {
        return (
            <>
                {plate.slice(0, pos)}
                {mark('·', `hiányzik: ${diff.searched}`)}
                {plate.slice(pos)}
            </>
        );
    }
    return (
        <>
            {plate.slice(0, pos)}
            {mark(
                plate[pos],
                diff.op === 'sub' ? `keresett: ${diff.searched}` : 'többlet karakter'
            )}
            {plate.slice(pos + 1)}
        </>
    );
}

export const plateSx = { fontFamily: 'monospace', fontWeight: 700, letterSpacing: 0.5 };
